import React from 'react';
import { motion, AnimatePresence } from 'motion/react';
import { useOnboarding } from 'context/onboarding.context';

export default function OnboardingWelcome() {
  const { showWelcome, startTour, dismissWelcome } = useOnboarding();

  return (
    <AnimatePresence>
      {showWelcome && (
        <>
          {/* Backdrop */}
          <motion.div
            key="welcome-backdrop"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            style={{
              position: 'fixed',
              inset: 0,
              backgroundColor: 'rgba(0,0,0,0.45)',
              zIndex: 19998,
            }}
          />

          {/* Card */}
          <motion.div
            key="welcome-card"
            initial={{ opacity: 0, y: 24, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 16, scale: 0.96 }}
            transition={{ type: 'spring', stiffness: 340, damping: 28 }}
            style={{
              position: 'fixed',
              bottom: 32,
              left: 32,
              zIndex: 19999,
              background: '#ffffff',
              borderRadius: 16,
              boxShadow: '0 12px 40px rgba(0,0,0,0.18)',
              padding: '20px 24px',
              width: 290,
              border: '2px solid #2ec291',
            }}
          >
            {/* Header accent bar */}
            <div
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                height: 4,
                background: 'linear-gradient(90deg, #2ec291, #1a7a5e)',
                borderRadius: '16px 16px 0 0',
              }}
            />

            <p
              style={{
                margin: 0,
                fontWeight: 700,
                fontSize: 14,
                color: '#0f172a',
                lineHeight: 1.4,
              }}
            >
              Baru pertama kali di sini?
            </p>
            <p
              style={{
                margin: '6px 0 16px',
                fontSize: 13,
                color: '#475569',
                lineHeight: 1.55,
              }}
            >
              Kami bisa tunjukkan menu-menu utama supaya toko Anda cepat siap jualan.
            </p>

            <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
              <button
                id="onboarding-skip-btn"
                onClick={dismissWelcome}
                style={{
                  background: 'transparent',
                  border: '1px solid #cbd5e1',
                  borderRadius: 8,
                  padding: '7px 16px',
                  fontSize: 13,
                  color: '#64748b',
                  cursor: 'pointer',
                  fontWeight: 500,
                  transition: 'border-color 0.2s, color 0.2s',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.borderColor = '#94a3b8';
                  e.currentTarget.style.color = '#1e293b';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.borderColor = '#cbd5e1';
                  e.currentTarget.style.color = '#64748b';
                }}
              >
                Nanti saja
              </button>
              <motion.button
                id="onboarding-start-btn"
                whileHover={{ scale: 1.03 }}
                whileTap={{ scale: 0.97 }}
                onClick={startTour}
                style={{
                  background: 'linear-gradient(135deg, #2ec291, #1a9b74)',
                  border: 'none',
                  borderRadius: 8,
                  padding: '7px 18px',
                  fontSize: 13,
                  color: '#ffffff',
                  cursor: 'pointer',
                  fontWeight: 600,
                  boxShadow: '0 2px 8px rgba(46,194,145,0.35)',
                }}
              >
                Ya, tunjukkan
              </motion.button>
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
}
